export const financeResellerAllSelector = (state) =>
  state?.financeResellerReducer?.financeResellerAll;
export const financeResellerOpenAddSelector = (state) =>
  state?.financeResellerReducer?.financeResellerOpenAdd;
export const financeResellerOpenEditSelector = (state) =>
  state?.financeResellerReducer?.financeResellerOpenEdit;
export const financeResellerSelectedSelector = (state) =>
  state?.financeResellerReducer?.financeResellerSelected;
export const financeResellerSearchSelector = (state) =>
  state?.financeResellerReducer?.financeResellerSearch;
export const financeResellerDatesSelector = (state) =>
  state?.financeResellerReducer?.financeResellerDates;
